import React, { useState, useEffect } from "react";
import rawgr_landing from "../../assets/rawgr-landing-page.gif";
import "../../App.css";
import LandingMain from "../LandingPage/LandingMain";

const GettingStarted = () => {
  const [showLanding, setShowLanding] = useState(false);

  useEffect(() => {
    const hasSeenLanding = localStorage.getItem("hasSeenLanding");
    if (hasSeenLanding) {
      setShowLanding(true);
    }
  }, []);

  const handleClick = () => {
    localStorage.setItem("hasSeenLanding", "true");
    setShowLanding(true);
  };

  return (
    <>
      {showLanding && <LandingMain />}
      {!showLanding && (
        <div className="App-header" onClick={handleClick}>
          <p>Click below to Get Started ...</p>
          <img src={rawgr_landing} className="App-logo" alt="logo" />
        </div>
      )}
    </>
  );
};

export default GettingStarted;
